import {AppDetails} from '@aboutyou/ui-components';
import iconUrl from './assets/app-logo.png';

export const sharedBannerData: Omit<AppDetails, 'storeUrl'> = {
  title: 'ABOUT YOU App',
  iconUrl,
  score: 4.8,
};

export const androidBannerData: Omit<AppDetails, 'storeUrl'> = {
  ...sharedBannerData,
  numRatings: 152700,
};

export const iosBannerData: Omit<AppDetails, 'storeUrl'> = {
  ...sharedBannerData,
  numRatings: 235800,
};
